import { HomeProvider } from './state/home-provider'
import HomeHeader from './components/home-header'
import StoreDirectorMessage from './components/store-director-message/store-director-message'
import LastFourWeeksPerformance from './components/last-four-weeks-performance'
import Weekly from './components/weekly/weekly'
import Yearly from './components/yearly'
import AlertBanner from './components/alert-banner/alert-banner'
import { useContext } from 'react'
import { HomeContext } from './state/home-context'
import HomeNoStore from './home-no-store'

const Home = () => {
  return (
    <div data-testid="dashboard" className="mg-homepage">
      <HomeProvider>
        <HomeContent />
      </HomeProvider>
    </div>
  )
}

const HomeContent = () => {
  const { storeId } = useContext(HomeContext)

  if (!storeId) {
    return <HomeNoStore />
  }

  return (
    <>
      <HomeHeader />
      <AlertBanner />
      <StoreDirectorMessage />
      <Weekly />
      <div className="mg-homepage-content">
        <LastFourWeeksPerformance />
        <Yearly />
      </div>
    </>
  )
}

export default Home
